// removed by extract-text-webpack-plugin
module.exports = {"marvelFill":"src-components-commons-ArrowLink-style----general-module---marvelFill---12fo0 fill-marvel fill-marvel--d--hover","blackFill":"src-components-commons-ArrowLink-style----general-module---blackFill---2opaq fill-black fill-licorice--hover"};


//////////////////
// WEBPACK FOOTER
// ./src/components/commons/ArrowLink/style/general.module.css
// module id = 1422
// module chunks = 168707334958949